/**
 * Plugin: axios
 * Link: https://github.com/axios/axios
 */

import axios from 'axios';
import CONFIG from './config';
import AuthService from './AuthService';
axios.defaults.baseURL = CONFIG.API;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.request.use(function (config) {

    // Do something before request is sent
    var auth_service = new AuthService();
    
    if (config.skipAuthorization) {
        return config;
    }else{
        config.headers.Authorization = "JWT " + auth_service.getToken();
    }
    // console.log(config)
    return config
}, function (error) {

    // Do something with request error
    return Promise.reject(error);

});
